export class ViewApplicationDetailsGtiaConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static FILE_NUMBER_LABEL = "File number";
    static APPLICATION_TYPE_LABEL = "Application type";
    static ZONE_LABEL = "New property zone";
    static FILE_NUMBER_FORM_CONTROL_NAME = "fileNumber";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPES_FORM_CONTROL_NAME = "applicationTypes";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static ZONES_FORM_CONTROL_NAME = "zones";
    static ZONE_FORM_CONTROL_NAME = "zone";
    static ADD_ZONE_LABEL = "Add zone";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static REFERENCE_NUMBER_CONTROL_NAME = "referenceNumber";
    static REZONING_APPLICATION_CONFIRMATION_CONTROL_NAME = "rezoneConfirmation";
    static REZONING_APPLICATION_CONFIRMATION_LABEL = "Is the application a rezoning application?";
    static REZONING_KEYWORD_REZONING = "rezoning";
    static REZONING_KEYWORD_REZONE = "rezone";
}
